export default "__VITE_ASSET__DARemUkD__"